import { SvgIcon, SxProps } from "@mui/material";
import SvgLinkIcon from "jsx:../../../Images/Icons/FontAwesome/light/link.svg";

export function LinkIcon(props: SxProps) {
    return <SvgIcon component={SvgLinkIcon} inheritViewBox sx={props} />;
}
